



















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({
  components: { }
})
export default class Modal<T> extends Vue {
  @Prop({ type: String, default: '对话框' }) title!: string

  // 废弃 改用width
  @Prop() modalWidth!: string

  @Prop({ type: String, default: '30vw' }) width!: string

  @Prop(Function) beforeConfirm!: () => Promise<T>

  @Prop(Function) beforeCancel!: () => Promise<T>

  @Prop({ type: String, default: '取消' }) cancelText!: string

  @Prop({ type: String, default: '确认' }) confirmText!: string

  @Prop({ type: Boolean, default: true }) footer!: boolean

  visible = false

  confirming = false

  concelling = false

  resolve: any = null

  reject: any = null

  params: any = null

  open (params?: any): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      this.params = params || {}
      this.resolve = resolve
      this.reject = reject
      this.visible = true
    })
  }

  onConfirm () {
    const vm = this as any
    if (!this.beforeConfirm) return handle(null as any)
    this.confirming = true
    this.beforeConfirm().then(data => {
      handle(data)
    }).catch(() => {
      this.confirming = false
    }).finally(() => {
      this.confirming = false
    })

    function handle (data: T) {
      if (vm.resolve) vm.resolve(data)
      vm.visible = false
    }
  }

  onCancel () {
    const vm = this as any
    if (!this.beforeCancel) return handle()
    this.concelling = true
    this.beforeCancel().then(() => {
      handle()
    }).finally(() => {
      this.concelling = false
    })

    function handle () {
      if (vm.reject) vm.reject()
      vm.visible = false
    }
  }
}
